import EmblaCarousel from 'embla-carousel'
import AutoHeight from 'embla-carousel-auto-height'
import { setupTweenScale } from '../vendor/embla/EmblaCarouselTweenScale'
import { addDotBtnsAndClickHandlers } from '../vendor/embla/EmblaCarouselDotButton'
import { addPrevNextBtnsClickHandlers } from '../vendor/embla/EmblaCarouselArrowButtons'

const OPTIONS = {
  loop: true,
  align: 'center',
  containScroll: 'trimSnaps'
}

// Auto Height plugin options
const AUTO_HEIGHT_OPTIONS = {
  destroyHeight: 'auto',
  heightNumber: 0, // Starting height
  responsive: true,
  // Add extra space to prevent content cut-off
  extraHeight: 40 // Extra pixels to add to the calculated height
}

function initEmblaCarousel() {
  const emblaNode = document.querySelector('.embla')
  const viewportNode = emblaNode?.querySelector('.embla__viewport')
  const prevBtn = emblaNode?.querySelector('.embla__button--prev')
  const nextBtn = emblaNode?.querySelector('.embla__button--next')
  const dotsNode = document.querySelector('.embla__dots')

  // Only initialize Embla if the required elements exist
  if (emblaNode && viewportNode) {
    const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [AutoHeight(AUTO_HEIGHT_OPTIONS)])
    const removeTweenScale = setupTweenScale(emblaApi)

    // Only set up buttons if they exist
    const removePrevNextBtnsClickHandlers = prevBtn && nextBtn
      ? addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn)
      : () => {}

    // Only set up dots if they exist
    const removeDotBtnsAndClickHandlers = dotsNode
      ? addDotBtnsAndClickHandlers(emblaApi, dotsNode)
      : () => {}

    emblaApi
      .on('destroy', removeTweenScale)
      .on('destroy', removePrevNextBtnsClickHandlers)
      .on('destroy', removeDotBtnsAndClickHandlers)
  }
}

export default initEmblaCarousel;
